import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { Partner, TripMatch } from '@marageti/z4-sdk/lib/travel';
import SubNavigationTripMatchView from './trip-match-sub-navigation-view';
import { TabItem } from '../sub-navigation/types';

const TRIP_LINKS: TabItem[] = [
  {
    e2e: 'ztest-trip-match-tab-about',
    label: 'about',
    to: '',
  },
  {
    e2e: 'ztest-trip-match-tab-messages',
    label: 'messages',
    to: 'messages',
    replace: false,
  },
  {
    e2e: 'ztest-trip-match-tab-documents',
    label: 'documents',
    to: 'documents',
  },
];

const SubNavigationTripMatchContainer = () => {
  const navigate = useNavigate();
  const { tripMatchId } = useParams();
  const apiClient = useApiClient();

  const { data: tripMatch } = useFetch<TripMatch>(apiClient.tripMatchesClient.getTripMatch, [tripMatchId], !!tripMatchId);
  const { data: partner } = useFetch<Partner>(apiClient.partnersClient.getPartner, [tripMatch?.partnerId], !!tripMatch?.partnerId);

  const handleBack = useCallback(() => {
    const targetPath = tripMatch?.tripRequestId ? `/trip-requests/${tripMatch.tripRequestId}` : '/';
    navigate(targetPath, { replace: true });
  }, [navigate, tripMatch?.tripRequestId]);

  return (
    <SubNavigationTripMatchView
      partner={partner}
      tabs={TRIP_LINKS}
      onBackClick={handleBack}
    />
  );
};

export default SubNavigationTripMatchContainer;
